"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseUtil = void 0;
const logger_1 = require("@linq/logger");
const Definitions_1 = require("./Definitions");
class ResponseUtil {
    static isArrayResponse(data) {
        return data.format === Definitions_1.OutputFormat.Array;
    }
    static isObjectResponse(data) {
        return data.format === Definitions_1.OutputFormat.KeyedJsonObject;
    }
    /**
     * cursor-based and index-based pagination response
     * @param data - data collection
     */
    static generateResponse(data) {
        // optional paging stats
        const pageSize = data.limit ?? data.collection.length;
        logger_1.Logger.debug(`${data.count} returned with pageSize of ${pageSize}`);
        // handle attribute based access control
        this.removeAttributes(data.collection, data.abacRestrictions);
        if (data.outputFormat === Definitions_1.OutputFormat.KeyedJsonObject) {
            const objecResponse = {
                count: data.collection.length,
                limit: pageSize,
                from: data.from,
                total: data.total,
                next: data.next,
                format: Definitions_1.OutputFormat.KeyedJsonObject,
                items: this.array2Object(data.collection, data.abacRestrictions, data.key),
            };
            return objecResponse;
        }
        const arrayResponse = {
            count: data.collection.length,
            limit: pageSize,
            from: data.from,
            total: data.total,
            next: data.next,
            format: Definitions_1.OutputFormat.Array,
            items: data.collection,
        };
        return arrayResponse;
    }
    /**
     * transforms an array of resource definitions to a keyed json object by given key
     * (default of id attribute)
     * mutates the response object given context aware attribute access restrictions
     * @param collection - collection/array of the api responses objects
     * @param abacRestrictions - attributes that should be redacted from output
     * @param key - attribute to use for key in json object.
     */
    static array2Object(collection, abacRestrictions, key = 'id') {
        return collection.reduce((acc, item) => {
            const deleteKeys = Object.keys(item).filter((attribute) => abacRestrictions?.includes(attribute));
            deleteKeys.forEach((attribute) => {
                delete item[attribute];
            });
            acc[item[key]] = item;
            return acc;
        }, {});
    }
    /**
     * verifies if object keys should be excluded from API response
     * mutates the response collection given context aware attribute access restrictions
     * @param collection - collection/array of the api responses objects
     * @param abacRestrictions - attribute access control restrictions
     */
    static removeAttributes(collection, abacRestrictions) {
        if (!abacRestrictions) {
            return collection;
        }
        logger_1.Logger.debug('removing protected resource attributes', abacRestrictions);
        return collection.map((item) => {
            const deleteKeys = Object.keys(item).filter((key) => abacRestrictions?.includes(key));
            deleteKeys.forEach((key) => {
                delete item[key];
            });
            return item;
        });
    }
}
exports.ResponseUtil = ResponseUtil;
//# sourceMappingURL=ResponseUtil.js.map